<ion-content class="camera-shell" [scrollY]="false" fullscreen>
  <div class="camera-stage" *ngIf="!capturedPhoto">
    <video
      #video
      autoplay
      muted
      playsinline
      [class.is-front]="facingMode === 'user'"
    ></video>

    <div class="camera-scrim"></div>
    <div class="camera-flash" *ngIf="shutterFlash"></div>

    <header class="camera-topbar">
      <div class="camera-title">
        <strong>{{ cameraTitleKey | translate }}</strong>
        <span>{{ cameraHintKey | translate }}</span>
      </div>

      <button
        type="button"
        class="camera-glass-btn camera-close-btn"
        data-testid="camera-close"
        (click)="dismiss()"
        [attr.aria-label]="'ACTIONS.CLOSE' | translate"
      >
        <ion-icon name="close"></ion-icon>
      </button>
    </header>

    <p class="camera-error" *ngIf="cameraError">
      {{ "CAMERA.UNAVAILABLE" | translate }}
    </p>

    <footer class="camera-dock">
      <button
        type="button"
        class="camera-shutter"
        data-testid="camera-take"
        (click)="takePhoto()"
        [disabled]="!!cameraError"
        [attr.aria-label]="'ACTIONS.TAKE_PHOTO' | translate"
      >
        <span></span>
      </button>

      <button
        type="button"
        class="camera-side-btn camera-flip-btn"
        (click)="flipCamera()"
        [attr.aria-label]="'CAMERA.FLIP' | translate"
      >
        <ion-icon name="camera-reverse"></ion-icon>
      </button>
    </footer>
  </div>

  <div class="camera-stage is-preview" *ngIf="finalImage && !isCropping">
    <img [src]="finalImage" alt="" />
    <div class="camera-scrim is-soft"></div>

    <header class="camera-topbar">
      <div class="camera-title">
        <strong>{{ "CAMERA.PREVIEW" | translate }}</strong>
      </div>
    </header>

    <footer class="camera-dock is-preview">
      <button
        type="button"
        class="camera-text-btn"
        *ngIf="!isGalleryMode"
        (click)="retake()"
      >
        <ion-icon name="refresh-outline"></ion-icon>
        {{ "CAMERA.RETAKE" | translate }}
      </button>

      <button
        type="button"
        class="camera-text-btn"
        *ngIf="isGalleryMode"
        (click)="dismiss()"
      >
        <ion-icon name="close-outline"></ion-icon>
        {{ "ACTIONS.CLOSE" | translate }}
      </button>

      <button type="button" class="camera-text-btn" (click)="startCrop()">
        <ion-icon name="crop-outline"></ion-icon>
        {{ "CAMERA.CROP" | translate }}
      </button>

      <button
        type="button"
        class="camera-text-btn is-primary"
        data-testid="camera-save"
        (click)="save()"
      >
        <ion-icon name="checkmark"></ion-icon>
        {{ "CAMERA.USE_PHOTO" | translate }}
      </button>
    </footer>
  </div>

  <div class="camera-stage is-crop" *ngIf="isCropping">
    <div class="cropper-wrapper">
      <image-cropper
        [imageBase64]="capturedPhoto!"
        [maintainAspectRatio]="aspectRatio"
        [aspectRatio]="1 / 1"
        format="jpeg"
        [alignImage]="'center'"
        [roundCropper]="false"
        (imageCropped)="onImageCropped($event)"
        (imageLoaded)="imageLoaded()"
        (loadImageFailed)="loadImageFailed()"
      >
      </image-cropper>
    </div>

    <footer class="camera-dock is-preview">
      <button
        type="button"
        class="camera-text-btn"
        (click)="isCropping = false"
      >
        {{ "COMMON.Cancel" | translate }}
      </button>
      <button
        type="button"
        class="camera-text-btn is-primary"
        (click)="confirmCrop()"
        [disabled]="!tempCroppedImage"
      >
        {{ "COMMON.Confirm" | translate }}
      </button>
    </footer>
  </div>
</ion-content>
